import { useCallback, useRef, useState } from 'react';
import clsx from 'clsx';

interface BackgroundVideoProps {
  src: string;
  fallback: string;
  className?: string;
}

/** Silent autoplay video background with static image fallback. */
export function BackgroundVideo(props: BackgroundVideoProps) {
  const [videoFailed, setVideoFailed] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleError = useCallback(() => setVideoFailed(true), []);

  return (
    <>
      <video
        data-testid="background-video"
        ref={videoRef}
        src={props.src}
        autoPlay
        muted
        loop
        playsInline
        onError={handleError}
        className={clsx(props.className, videoFailed ? 'opacity-0' : 'opacity-100')}
      />
      <img
        data-testid="background-video-fallback"
        src={props.fallback}
        alt=""
        aria-hidden
        className={clsx(
          props.className,
          'pointer-events-none',
          videoFailed ? 'opacity-100' : 'opacity-0',
        )}
      />
    </>
  );
}
